import React from "react";
import { Typography } from "@mui/material";

import FooterButtons from "./FooterButtons";
import SimplePaper from "../components/SimplePaper";
const TermsAndConditions = () => {
  const title = "Terms and Conditions";

  const body = (
    <>
      <Typography variant="body1" paragraph>
        Welcome to AstroData. By accessing or using our website and services,
        you agree to comply with and be bound by the following terms and
        conditions. Please read these terms carefully before using our services.
        If you do not agree to these terms, you may not access or use our
        website or services.
      </Typography>

      <Typography variant="h4" gutterBottom>
        1. Acceptance of Terms
      </Typography>
      <Typography variant="body1" paragraph>
        By using our website and services, you agree to these Terms and
        Conditions and to comply with all applicable laws and regulations. These
        terms apply to all visitors, users, and others who access or use our
        services.
      </Typography>

      <Typography variant="h4" gutterBottom>
        2. Use of Our Services
      </Typography>
      <Typography variant="body1" paragraph>
        You agree to use our services only for lawful purposes and in accordance
        with these terms. You agree not to use our services:
      </Typography>
      <Typography variant="body1" paragraph>
        - In any way that violates any applicable local, national, or
        international law or regulation.
        <br />
        - To engage in any activity that is fraudulent, harmful, or misleading.
        <br />
        - To transmit, or procure the sending of, any advertising or promotional
        material without our prior written consent.
        <br />- To impersonate or attempt to impersonate AstroData, a AstroData
        employee, another user, or any other person or entity.
      </Typography>

      <Typography variant="h4" gutterBottom>
        3. Account Registration
      </Typography>
      <Typography variant="body1" paragraph>
        To access certain features of our services, you may be required to
        register an account. You agree to provide accurate, current, and
        complete information during the registration process and to update such
        information to keep it accurate, current, and complete. You are
        responsible for maintaining the confidentiality of your account and
        password and for restricting access to your computer or device. You
        agree to accept responsibility for all activities that occur under your
        account or password.
      </Typography>

      <Typography variant="h4" gutterBottom>
        4. Intellectual Property Rights
      </Typography>
      <Typography variant="body1" paragraph>
        The content, design, layout, look, appearance, and graphics of our
        website and services are protected by intellectual property rights. You
        agree not to reproduce, duplicate, copy, sell, resell, or exploit any
        portion of our services without express written permission from us.
      </Typography>

      <Typography variant="h4" gutterBottom>
        5. Privacy Policy
      </Typography>
      <Typography variant="body1" paragraph>
        Your use of our website and services is also governed by our Privacy
        Policy. Please review our Privacy Policy to understand our practices
        regarding the collection, use, and disclosure of your personal
        information.
      </Typography>

      <Typography variant="h4" gutterBottom>
        6. Limitation of Liability
      </Typography>
      <Typography variant="body1" paragraph>
        To the fullest extent permitted by applicable law, AstroData shall not
        be liable for any indirect, incidental, special, consequential, or
        punitive damages, or any loss of profits or revenues, whether incurred
        directly or indirectly, or any loss of data, use, goodwill, or other
        intangible losses, resulting from (a) your use or inability to use our
        services; (b) any unauthorized access to or use of our servers and/or
        any personal information stored therein; (c) any interruption or
        cessation of transmission to or from our services; and (d) any bugs,
        viruses, trojan horses, or the like that may be transmitted to or
        through our services by any third party.
      </Typography>

      <Typography variant="h4" gutterBottom>
        7. Indemnification
      </Typography>
      <Typography variant="body1" paragraph>
        You agree to indemnify, defend, and hold harmless AstroData, its
        officers, directors, employees, and agents, from and against any and all
        claims, damages, obligations, losses, liabilities, costs, or debt, and
        expenses (including but not limited to attorney's fees) arising from:
        (a) your use of and access to our services; (b) your violation of any
        term of these terms; (c) your violation of any third-party right,
        including without limitation any intellectual property, or privacy
        right; or (d) any claim that your use of our services caused damage to a
        third party.
      </Typography>

      <Typography variant="h4" gutterBottom>
        8. Termination
      </Typography>
      <Typography variant="body1" paragraph>
        We may terminate or suspend your account and access to our services
        immediately, without prior notice or liability, if you breach any of
        these terms. Upon termination, your right to use our services will cease
        immediately. If you wish to terminate your account, you may simply
        discontinue using our services.
      </Typography>

      <Typography variant="h4" gutterBottom>
        9. Governing Law
      </Typography>
      <Typography variant="body1" paragraph>
        These terms shall be governed and construed in accordance with the laws
        of India, without regard to its conflict of law provisions. Our failure
        to enforce any right or provision of these terms will not be considered
        a waiver of those rights. If any provision of these terms is held to be
        invalid or unenforceable by a court, the remaining provisions of these
        terms will remain in effect.
      </Typography>

      <Typography variant="h4" gutterBottom>
        10. Changes to Terms and Conditions
      </Typography>
      <Typography variant="body1" paragraph>
        AstroData reserves the right to modify or replace these terms at any
        time. If a revision is material, we will try to provide at least 30 days
        notice prior to any new terms taking effect. What constitutes a material
        change will be determined at our sole discretion. By continuing to
        access or use our services after those revisions become effective, you
        agree to be bound by the revised terms.
      </Typography>

      <Typography variant="h4" gutterBottom>
        11. Contact Us
      </Typography>
      <Typography variant="body1" paragraph>
        If you have any questions about these Terms and Conditions, please
        contact us at support@astrodata.app
      </Typography>
    </>
  );

  return (
    <>
      <SimplePaper title={title} body={body} />
      <FooterButtons />
    </>
  );
};

export default TermsAndConditions;
